import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DictionaryModule } from '@sdbn/common';
import { VisitorRegistrationSummaryComponent } from './component/visitor-registration-summary.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';

import { MatCardModule as MatCardModule } from '@angular/material/card';


@NgModule({
  declarations: [
    VisitorRegistrationSummaryComponent
  ],
  imports: [
    CommonModule,

    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonLayoutModule,
    MatCardModule
  ]
})
export class VisitorRegistrationSummaryModule { }
